import {
    addDoc,
    collection,
    doc,
    getDoc,
    getDocs,
    query,
    setDoc,
    where,
    orderBy,
    limit
} from "firebase/firestore";
import {fireStoreDB} from "../../firebase/client-app";
import {Promise} from "bluebird";
import _ from "lodash";
import {DATA_LIMIT} from "../constants/media.constant";

export {
    addMedias,
    addSingleMedia,
    updateSingleMedia,
    getSingleMedia,
    getAllMedias,
    searchMedias,
    searchMediasWithSearchCriteria,
    prepareMediasList
}

const collectionName = 'medias';
const collectionReference = collection(fireStoreDB, collectionName);

const addMedias = (medias) => {
    return Promise.map(medias, async media => {
        await addSingleMedia(media);
    });
}

const addSingleMedia = async (media) => {
    media.createdAt = new Date();
    media.updatedAt = media.createdAt;
    return addDoc(collectionReference, media);
}

const updateSingleMedia = (media) => {
    const documentReference = doc(fireStoreDB, collectionName, media.id);
    media.updatedAt = new Date();
    return setDoc(documentReference, media);
}

const getSingleMedia = async (mediaId) => {
    const documentReference = doc(fireStoreDB, collectionName, mediaId);
    const mediaDoc = await getDoc(documentReference);
    return prepareSingleMedia(mediaDoc);
}

const getAllMedias = async () => {
    let searchQuery = query(collectionReference);
    const mediasResult = await getDocs(searchQuery);
    return prepareMediasList(mediasResult);
}

const searchMedias = async (searchText, perPage = DATA_LIMIT) => {
    let searchQuery = query(collectionReference);

    if (searchText) {
        searchQuery = query(collectionReference, where("textList", "array-contains", searchText));
    }

    searchQuery = query(searchQuery,
        orderBy('updatedAt', 'desc'));

    searchQuery = query(searchQuery, limit(perPage));

    const mediaResult = await getDocs(searchQuery);
    return prepareMediasList(mediaResult);
}

const searchMediasWithSearchCriteria = async (searchCriteriaList, perPage = DATA_LIMIT) => {
    let searchQuery = query(collectionReference);

    _.forEach(searchCriteriaList, searchCriteria => {
        searchQuery = query(searchQuery,
            where(searchCriteria.field, searchCriteria.condition, searchCriteria.value));
    });

    /*if (searchCriteriaList.length === 0) {
        searchQuery = query(searchQuery, orderBy('updatedAt', 'desc'));
    }*/

    searchQuery = query(searchQuery, orderBy('updatedAt', 'desc'));
    searchQuery = query(searchQuery, limit(perPage));

    const mediaResult = await getDocs(searchQuery);
    return prepareMediasList(mediaResult);
}

const prepareMediasList = (mediaResult) => {
    const mediasList = [];

    _.forEach(mediaResult.docs, mediaDoc => {
        mediasList.push(prepareSingleMedia(mediaDoc));
    });

    return mediasList;
}


const prepareSingleMedia = (mediaDoc) => {
    const media = mediaDoc.data();
    media.id = mediaDoc.id;
    return media;
}
